import React from "react";
import LimitTemplate from "../Common";
import limitsApi from "../../../api/limits";
import reports from "../../../api/reports";

export const WebLimit = () => (
  <LimitTemplate
    header="Web limits"
    requestApi={limitsApi.getLimitsListWeb}
    requestReport={reports.requestLimitsListWeb}
  />
);
